import { Component, Injectable, OnInit, Input } from "@angular/core";
import { CommonService } from "../service/common.service";
import { YoyakuService } from '../service/yoyaku.service';
import { Location } from "@angular/common";
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Injectable()
export class I18n {
  language = "ja";
}

@Component({
  selector: "yoyaku-list-add-app",
  templateUrl: "./yoyaku-list-add.component.html",
  styleUrls: ["yoyaku-list-add.component.css"],
})
export class YoyakuListAddComponent implements OnInit {
  @Input() selectedId: any[];

  private previousUrl: string = undefined;
  private currentUrl: string = undefined;

  constructor(
    private commonService: CommonService,
    public activeModal: NgbActiveModal,
    private yoyakuService: YoyakuService,
    private location: Location
  ) {}

  isLoaded: boolean = false;
  dataList: any = [];
  err1: boolean = false;
  err2: boolean = false;
  ret: any = {
    status: "",
    selectedData: [],
  }
  //起動時処理
  ngOnInit(): void {
    this.getList();
  };
  getList():void{
    this.yoyakuService.getAdminCustomize38(this.selectedId)
      .subscribe((res: Response) => {
          if (res["fuel_status"] == "OK") {
            this.dataList = res["fuel_results"];
            this.isLoaded = true;
          }else if (res["fuel_status"] == "NG") {
              this.commonService.modalOpens(res["fuel_message"],modalresult=>{});
          }else{
              this.commonService.modalOpens(11003,modalresult=>{});
          }
      }, error => {
          this.commonService.modalOpens(error,modalresult=>{});
      });
  }
  save(): void {
    let param = {
      'm_yoyakuhyo_id': this.selectedId,
      'data':[
        {
          'm_question_kbn_id': this.dataList[0].m_question_kbn_id,
          'm_question_ids': this.dataList[0].m_question_ids,
          'update_datetime': this.dataList[0].update_datetime,
        },
        {
          'm_question_kbn_id': this.dataList[1].m_question_kbn_id,
          'm_question_ids': this.dataList[1].m_question_ids,
          'update_datetime': this.dataList[1].update_datetime,
        }
      ]
    }
    this.commonService.modalOpens(50001,
      //保存してもよろしいですか？
      modalresult => {
        if (modalresult == "OK") {
          this.yoyakuService.saveCustomize38(param)
              .subscribe((res: Response) => {
                  if (res["fuel_status"] == "OK") {
                      this.commonService.modalOpens(10001, modalresult => {
                        this.ret.status = 'OK';
                        this.activeModal.close(this.ret);
                      });
                  }else if (res["fuel_status"] == "NG") {
                      this.commonService.modalOpens(res["fuel_message"],modalresult=>{});
                  }else{
                      this.commonService.modalOpens(11003,modalresult=>{});
                  }
              }, error => {
                  this.commonService.modalOpens(error,modalresult=>{});
              });
        } else {
          //
        }
      }
    );
  }
  //キャンセル時
  check(ids: any, mode: number): boolean {
    if(ids != null && ids != ""){
      if(ids.match(/\b\d{1}(,\d{1})*\b$/)){
        if(mode==0){
          this.err1 = false;
        }else{
          this.err2 = false;
        }
        return false;
      }else{
        if(mode==0){
          this.err1 = true;
        }else{
          this.err2 = true;
        }
        return true;
      }
    }else{
      if(mode==0){
        this.err1 = false;
      }else{
        this.err2 = false;
      }
      return false;
    }
  }
  //キャンセル時
  Cancel() {
    this.ret.status = 'Cancel';
    this.activeModal.close(this.ret);
  }
}



// WEBPACK FOOTER //
// ./src/app/g3801-yoyaku-list-add/yoyaku-list-add.component.ts